import React from 'react';
import { connect } from 'react-redux';
import { Glyphicon, Button, InputGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import NavigationItem from '../../components/flow/navigation-item';
import GraphSource from '../../sources/graph';
import Model from '../../utils/model';
import DragContext from '../../utils/dragDropContext';

import { CSSTransitionGroup } from 'react-transition-group';

class NavigationEditor extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: null,
            mapElements: null,
            editing: null,
            name: null,
            label: null,
            mapElement: null,
            errors: {
                name: false,
                label: false,
                mapElement: false
            },
            isNewItem: false
        };
    }

    UNSAFE_componentWillMount() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        if (!model.objectData) {
            model.objectData = [];
        }

        const flowId = model.tags.filter((tag) => manywho.utils.isEqual(tag.developerName, 'FlowId', true))[0].contentValue;

        GraphSource.get(flowId, this.props.tenantId, this.props.authenticationToken)
            .then((response) => {
                const mapElements = response.mapElements.sort((a, b) => {
                    if (a.developerName < b.developerName)
                        return -1;
                    else if (a.developerName > b.developerName)
                        return 1;
                    else
                        return 0;
                });

                this.setState({
                    items: model.objectData,
                    mapElements: mapElements
                });
            });
    }

    componentDidMount() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        manywho.state.setComponent(this.props.id, { objectData: model.objectData }, this.props.flowKey, false);
    }

    findItem = (itemId, items) => {
        if (items) {
            for (let item of items) {
                const id = manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue;
                if (id == itemId) {
                    return item;
                }
                var foundItem = this.findItem(itemId, manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData);
                if (foundItem) {
                    return foundItem;
                }
            }
        }
    }

    updateItem = (items, itemId, name, label, mapElement) => {
        if (items) {
            return items.map((item) => {
                const id = manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue;
                if (id == itemId) {
                    manywho.utils.getObjectDataProperty(item.properties, 'DeveloperName').contentValue = name;
                    manywho.utils.getObjectDataProperty(item.properties, 'Label').contentValue = label;
                    manywho.utils.getObjectDataProperty(item.properties, 'LocationMapElementId').contentValue = mapElement;
                }
                let navItems = manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData;
                this.updateItem(navItems, itemId, name, label, mapElement);
                return item;
            });
        }
    }

    deleteItem = (items, itemId) => {
        if (items) {
            let foundItem = false;
            const newItems = [];
            for (const item of items) {
                manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData = this.deleteItem(manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData, itemId);
                if (foundItem) {
                    manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue--;
                }
                if (manywho.utils.isEqual(manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue, itemId, true)) {
                    foundItem = true;
                } else {
                    newItems.push(item);
                }
            }
            return newItems;
        }
    }

    addItem = (id, e) => {
        e.preventDefault();
        e.stopPropagation();

        const newId = Model.guid();

        this.setState({
            editing: newId,
            editingParent: id,
            name: "",
            label: "",
            mapElement: "",
            isNewItem: true
        });
    }

    onItemClick = (e) => {
        e.nativeEvent.preventDefault();
        e.stopPropagation();

        const itemId = e.currentTarget.id || null;

        const item = this.findItem(itemId, this.state.items);

        this.setState({
            editing: itemId,
            name: manywho.utils.getObjectDataProperty(item.properties, 'DeveloperName').contentValue,
            label: manywho.utils.getObjectDataProperty(item.properties, 'Label').contentValue,
            mapElement: manywho.utils.getObjectDataProperty(item.properties, 'LocationMapElementId').contentValue,
            isNewItem: false,
            errors: {}
        });
    }

    onCancelEdit = () => {
        this.setState({
            editing: null,
            name: null,
            label: null,
            mapElement: null,
            isNewItem: false
        });
    }

    updateLabel = (e) => {
        e.preventDefault();

        const errors = this.state.errors;
        delete errors.label;
        this.setState({ label: e.currentTarget.value, errors });
    }

    updateMapElement = (e) => {
        e.preventDefault();

        const selectedMapElement = this.state.mapElements.find(item => item.id === e.currentTarget.value);

        const errors = this.state.errors;
        delete errors.mapElement;
        this.setState({
            mapElement: e.currentTarget.value,
            name: selectedMapElement.developerName,
            errors
        });

        if (manywho.utils.isNullOrEmpty(this.state.label)) {
            this.setState({ label: selectedMapElement.developerName });
        }
    }

    save = (e) => {
        e.preventDefault();

        let errors = {};

        if (manywho.utils.isNullOrEmpty(this.state.label))
            errors.label = true;

        if (manywho.utils.isNullOrEmpty(this.state.mapElement))
            errors.mapElement = true;

        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return false;
        }

        let newItems = null;

        if (this.state.isNewItem) {

            let order = 0;

            if (this.state.editingParent != null && this.state.editingParent.length > 0) {
                const item = this.findItem(this.state.editingParent, this.state.items);

                if (!manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData) {
                    manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData = [];
                }

                order = manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData.length;
            } else {
                order = this.state.items.length;
            }

            const mapElement = this.state.mapElements.find(item => item.id === this.state.mapElement);

            const newItem = {
                developerName: "NavigationItem",
                isSelected: false,
                order: 0,
                typeElementId: "72923f7c-2ca2-422b-ba0f-46235a02b558",
                properties: [
                    {
                        contentType: "ContentString",
                        developerName: "Id",
                        contentValue: this.state.editing,
                        typeElementPropertyId: "a5fd4339-e9e2-452f-a65b-60e73b3a4ba4"
                    },
                    {
                        contentType: "ContentString",
                        developerName: "LocationMapElementId",
                        contentValue: this.state.mapElement,
                        typeElementPropertyId: "4b03c0f6-8c3e-4e1d-b5ec-8b64a0abf4c3"
                    },
                    {
                        contentType: "ContentString",
                        developerName: "DeveloperName",
                        contentValue: mapElement.developerName,
                        typeElementPropertyId: "e83d69a3-f1c7-49bf-b948-314154941e1d"
                    },
                    {
                        contentType: "ContentString",
                        developerName: "Label",
                        contentValue: this.state.label,
                        typeElementPropertyId: "7900b60d-6222-4cd9-8eb5-894f61d6ca07"
                    },
                    {
                        contentType: "ContentList",
                        developerName: "NavigationItems",
                        objectData: null,
                        typeElementPropertyId: "727b74dd-7d28-469c-bfa6-62691ce2b77e"
                    },
                    {
                        contentType: "ContentNumber",
                        developerName: "Order",
                        contentValue: order,
                        typeElementPropertyId: "a02d5b6e-ea2d-4a50-9b66-a7601d7425a0"
                    }
                ]
            };

            if (this.state.editingParent != '') {
                newItems = this.state.items;
                const item = this.findItem(this.state.editingParent, newItems);

                manywho.utils.getObjectDataProperty(item.properties, 'NavigationItems').objectData.push(newItem);
            } else {
                newItems = this.state.items;

                newItems.push(newItem);
            }

            manywho.state.setComponent(this.props.id, { objectData: newItems }, this.props.flowKey, false);
        } else {
            newItems = this.updateItem(this.state.items, this.state.editing, this.state.name, this.state.label, this.state.mapElement);

            manywho.state.setComponent(this.props.id, { objectData: newItems }, this.props.flowKey, false);
        }


        this.setState({
            editing: null,
            editingParent: null,
            items: newItems,
            name: null,
            label: null,
            mapElement: null,
            isNewItem: false
        });
    }

    delete = () => {
        const items = this.deleteItem(this.state.items, this.state.editing);

        manywho.state.setComponent(this.props.id, { objectData: items }, this.props.flowKey, false);

        this.setState({
            editing: null,
            editingParent: null,
            items: items,
            name: null,
            label: null,
            mapElement: null,
            isNewItem: false
        });
    }

    moveItem = (parent, id, order) => {
        let items = parent ? manywho.utils.getObjectDataProperty(parent.properties, 'NavigationItems').objectData: this.state.items;
        const item = this.findItem(id, items);
        const oldOrder = manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue;
        items = this.orderItems(items, parseInt(oldOrder), parseInt(order));
        manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue = order;
        if (parent) {
            const newItems = this.state.items;
            manywho.utils.getObjectDataProperty(parent.properties, 'NavigationItems').objectData = items;
            let parentItem = this.findItem(manywho.utils.getObjectDataProperty(parent.properties, 'Id').contentValue, newItems);
            parentItem = parent;
            items = newItems;
        }
        this.setState({
            items: items
        });
    }

    orderItems = (items, oldIndex, newIndex) => {
        const delta = Math.abs(newIndex - oldIndex);
        return items.map((item) => {
            const order = parseInt(manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue);
            if (newIndex > oldIndex) {
                if (order <= newIndex && order > newIndex - delta ) {
                    manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue = parseInt(manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue) - 1;
                }
            } else {
                if (order < oldIndex && order >= oldIndex - delta ) {
                    manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue = parseInt(manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue) + 1;
                }
            }
            return item;
        });
    }

    render() {
        let optionStyle = {};

        let navigation = null;
        let form = null;

        if (this.state.mapElements) {
            const options = this.state.mapElements.map((option) => {
                return <option key={option.id} value={option.id}>{option.developerName}</option>;
            });

            if (this.state.mapElement != null && this.state.mapElement.length > 0) {
                optionStyle = { display: 'none' };
            }
            options.unshift(<option key="default" value="" disabled style={ optionStyle }> -- Select a Map Element -- </option>);

            const items = this.state.items
                .sort((item1, item2) => {
                    return parseInt(manywho.utils.getObjectDataProperty(item1.properties, 'Order').contentValue) - parseInt(manywho.utils.getObjectDataProperty(item2.properties, 'Order').contentValue);
                })
                .map((item) => {
                    const key = manywho.utils.getObjectDataProperty(item.properties, 'Id').contentValue;
                    return React.createElement(NavigationItem, { items: this.state.items, parent: null, item: item, key: key, isTopLevel: true, moveItem: this.moveItem, itemClick: this.onItemClick, addItem: this.addItem, findItem: this.findItem });
            });

            items.push(<li key={'add-item'} className="add-item" onClick={this.addItem.bind(null, '')}><a href="#"><Glyphicon glyph="plus"></Glyphicon></a></li>);

            if (this.state.items) {
                navigation = <div className="collapse navbar-collapse">
                    <ul className="nav navbar-nav">
                        {items}
                    </ul>
                </div>;
            }

            const deleteButton = !this.state.isNewItem && <Button bsStyle="danger" onClick={this.delete} className="outcome">Delete</Button>;

            if (this.state.editing) {

                form = <div className="navigation-input" key="form">
                    <div className="mw-inline_flow clearfix">
                        <div>
                            <InputGroup className={'pull-left ' + (this.state.errors.mapElement ? 'has-error' : null)}>
                                <ControlLabel>Navigate To </ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.mapElement}
                                    onChange={this.updateMapElement}
                                    required={true}
                                >
                                {
                                    options
                                }
                                </FormControl>
                                {
                                    this.state.errors.mapElement ? <HelpBlock>A Map Element is required</HelpBlock> : null
                                }
                            </InputGroup>

                            <InputGroup className={'pull-left ' + (this.state.errors.label ? 'has-error' : null)}>
                                <ControlLabel>Label </ControlLabel>
                                <FormControl
                                    type='text'
                                    value={this.state.label}
                                    onChange={this.updateLabel}
                                    required={true}
                                />
                                {
                                    this.state.errors.label ? <HelpBlock>A Label is required</HelpBlock> : null
                                }
                            </InputGroup>
                        </div>
                    </div>
                    <div className="add-navigation-actions">
                        <Button bsStyle="default" onClick={this.onCancelEdit} className="outcome">Cancel</Button>
                        <Button bsStyle="primary" onClick={this.save} className="outcome">Save</Button>
                        {deleteButton}
                    </div>
                </div>;
            }

            return <div>
                <h3>Preview</h3>
                <p>Drag & drop to move navigation items. Click the plus icon to add new items</p>
                <nav className="navbar navbar-inverse navbar-editor">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#">
                            <span type="button" className="sr-only">Toggle Navigation</span>
                            <span type="button" className="icon-bar"></span>
                            <span type="button" className="icon-bar"></span>
                            <span type="button" className="icon-bar"></span>
                        </button>
                    </div>
                    {navigation}
                </nav>
                <CSSTransitionGroup transitionName="form" transitionAppearTimeout={500} transitionLeaveTimeout={300}>
                    {form}
                </CSSTransitionGroup>
            </div>;
        }

        return React.createElement(manywho.component.getByName('wait'), { isVisible: true });
    }

}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
)(DragContext(NavigationEditor));
